import apptracker from '@utils/sensor/apptracker';
import { Result } from 'antd';
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    apptracker('error-boundary', { ...this.state });
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <div>
          <Result status="warning" subTitle="Something went wrong." />
        </div>
      );
    }
    // Normally, just render children
    return <React.Fragment key="error-boundary">{this.props.children}</React.Fragment>;
  }
}

export default ErrorBoundary;
